<template>
    <div>
        <MercenaryHeader :title="'코치 소개 미디어'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; overflow:auto;background-color: #f5f5f5; padding:12px;">
            <template v-if="(youtube_link || image_path)">
                <div class="title" style="margin-top:20px; display:flex;">
                    <span>내가 등록한 미디어</span>
                    <div style="flex:1;"></div>
                    <div style="display:grid; place-items: center;" @click="() => {isShowPopupMenu = true}">
                        <img :src="require('@/assets/option_black_horizontal.png')" style="width:16px; height:4px; transform:rotate(90deg)" >
                    </div>
                </div>
                <div>
                    <div v-if="youtube_link" style="border-radius:12px; overflow: hidden;" >
                        <ContentsViewer :contents="youtube_link" />
                    </div>
                    <img ref="introduce_image" style="width:100%; border-radius:12px;" :src="image_path" >
                </div>
            </template>
            <input ref="image_file" type="file" style="display:none;" @change="readURL($event)" accept="image/*">

            <template v-if="!isHideRequest">
                <div class="title" style="margin-top:20px;">요청하기<span style="float:right; color:#FF7111; font-size:14px; font-weight:500;" @click="hideRequest">관심없음</span></div>
                <div class="container" style="text-align:center; padding:20px 12px;">
                    <div style="color:#210F03; font-size:16px; font-weight:500;">코치 소개 영상을 제작할 수 있습니다.</div>
                    <div style="color:#210F03; font-size:20px; font-weight:bold; margin-top:5px;">사커하우팀에 영상 제작을 요청하세요.</div>
                    <div style="color:#606060; font-size:14px; font-weight:500; white-space: pre-wrap;line-height: 24px; margin-top:16px;">사커하우팀에서 코치 소개 영상을 자체적으로 제작하고 있습니다. 영상 촬영을 요청하고 코치님만의 소개 영상을 만들어보세요.</div>
                    <div style="display:grid; place-items: center; margin-top:20px;">
                        <div v-if="isRequested" style="width:92px; height:48px; display:grid; place-items: center; border-radius:12px; background-color:#EBEBEB; color:#D9D9D9; font-size:14px; font-weight:500;" >요청 완료</div>
                        <div v-else style="width:144px; height:48px; display:grid; place-items: center; border:1px solid #210F03; border-radius:12px; font-size:14px; font-weight:500;" @click="() => {isShowRequest = true}">영상 제작 요청하기</div>
                    </div>
                </div>
            </template>


            <div class="title" style="margin-top:20px;">미디어 등록하기</div>

            <div style="display:flex; justify-content: center; gap: 20px; padding:10px 0px;">
                <div @click="showFiles">
                    <img :src="require('@/assets/img/soccerhow_write_album_white.png')" style="width:80px; height:80px;">
                </div>
                <div @click="() => {isShowLink = true}">
                    <img :src="require('@/assets/img/soccerhow_write_link_white.png')" style="width:80px; height:80px;">
                </div>
            </div>

            <div></div>

        </div>

        <CommonPopupFrame :changeHeight="460" :change-height-unit="'px'" :closeCompleteAction="() => {isShowLink = false}" :isOpen="isShowLink" :changeBottom="0" :is-back-press-apply="true">
            <div style="height:20px;">
                <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
            </div>
            <div style="display:grid;place-items:center;width:60px; color:#FF7111; font-size:16px; font-weight:bold;" @click="() => {isShowLink = false}">닫기</div>
            <div style="flex:1; display: flex; flex-direction: column; overflow:hidden; padding:12px; text-align:center;" @touchmove.stop="() => {}">
                <div style="color:#210F03; font-size:32px; font-weight:bold;">링크 추가하기</div>
                <div style="color:#210F03; font-size:16px; font-weight:500; margin-top:20px; margin-bottom:20px;">유튜브 링크를 첨부하세요</div>
                <div v-if="is_youtube_link">
                    <div style="border-radius:12px; overflow: hidden;">
                        <ContentsViewer :contents="temp_youtube_link" />
                    </div>
                    <div style="display:flex; margin-top:10px;">
                        <div style="flex:1;"></div>
                        <div style="color:#FF7111; font-size:14px; font-weight:bold;" @click="deleteUrl">URL 삭제</div>
                    </div>
                </div>
                <div v-else style="background-color: #f5f5f5; height:56px; font-size:14px; font-weight:500; color:#BBBBBB;position:relative; padding:0px 10px;display:flex; align-items: center; border-radius:12px; m">
                    <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="width:20px; height:18px; " >
                    <input type="text" class="youtube_link_input" style="" v-model="temp_youtube_link" @blur="checkYoutube" @keyup="checkYoutube">
                </div>
                <div style="flex:1;"></div>
                <div style="">
                    <div class="btn" :class="[temp_youtube_link ? 'active' : '']" style="" @click="() => {youtube_link !== temp_youtube_link ? save(true) : ''}">등록하기</div>
                </div>
            </div>
        </CommonPopupFrame>

        <CommonPopupFrame :changeHeight="600" :change-height-unit="'px'" :closeCompleteAction="() => {isShowRequest = false}" :isOpen="isShowRequest" :changeBottom="0" :is-back-press-apply="true">
            <div style="height:20px;">
                <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
            </div>
            <div style="display:flex;">
                <div style="width:50px; display:grid; place-items: center;" @click="() => {isShowRequest = false}">
                    <img :src="require('@/assets/img/close_rect.png')" style="width:40px; height:40px;">
                </div>
                <div style="flex:1; display:grid; place-items: center; color:#210F03; font-size:16px; font-weight:bold;">요청하기</div>
                <div style="width:50px;"></div>
            </div>
            <div style="flex:1; display:flex; flex-direction: column;padding:12px;">
                <div style="padding:30px 0px 20px 0px; text-align:center;">
                    <img :src="require('@/assets/img/media_request.png')" style="width:57px; height:52px;">
                </div>
                <div style="">
                    <div class="explanation_title"><div class="explanation_front">1.</div>사커하우팀에서 영상 제작 요청하세요</div>
                    <div class="explanation">
                        <div class="explanation_front">·</div>
                        <div class="explanation_back">사커하우팀은 코치님의 프로필에 들어갈 소개 영상을 제작하고 있습니다.</div>
                    </div>

                    <div class="explanation_title" style="margin-top:30px;"><div class="explanation_front">2.</div>코치님에게 관심을 주목시키세요</div>
                    <div class="explanation">
                        <div class="explanation_front">·</div>
                        <div class="explanation_back">코치 소개 영상은 코치님에 대한 이해도를 높이는 데에 도움이 되며 코치님에 대한 신뢰도를 높이기도 합니다.</div>
                    </div>

                    <div class="explanation_title" style="margin-top:30px;"><div class="explanation_front">3.</div>무료로 요청하세요</div>
                    <div class="explanation">
                        <div class="explanation_front">·</div>
                        <div class="explanation_back">아래 버튼만 누르면 바로 요청이 발송됩니다. 이후 사커하우팀에서 개인적으로 연락을 드릴 예정입니다.</div>
                    </div>
                    <div class="explanation">
                        <div class="explanation_front">·</div>
                        <div class="explanation_back">사전 인터뷰를 진행 후 촬영 일정을 맞추고 촬영에 대한 안내를 받기만 하면 끝입니다.</div>
                    </div>
                </div>
                <div style="flex:1;"></div>
                <div style="">
                    <div class="btn active" @click="requestMaking">영상 제작 요청하기</div>
                </div>
            </div>
        </CommonPopupFrame>

        <transition name="fade">
            <div v-if="isShowRequestComplete">
                <div style="background-color: #45372d; border-radius:12px; width:263px; height:72px; display: grid; place-items: center; position:fixed; bottom:100px; left:50%; transform: translateX(-50%);">
                    <div>
                        <div style="color:white; font-weight:bold; font-size:12px; text-align:center;">요청이 완료됐습니다.</div>
                        <div style="color:white; font-weight:bold; font-size:12px; text-align:center; margin-top:13px;">확인 후 연락드리겠습니다.</div>
                    </div>
                </div>
            </div>
        </transition>

        <BottomPopupMenu :is-open="isShowPopupMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import CommonPopupFrame from "../my/CommonPopupFrame";
    import ContentsViewer from "../../common/ContentsViewer";
    import ResponseCode from "../../../ResponseCode";
    import BottomPopupMenu from "../../common/BottomPopupMenu";
    export default {
        name: "CoachIntroduceManage",
        components: {BottomPopupMenu, ContentsViewer, CommonPopupFrame, MercenaryHeader},
        data(){
            return {
                isShowLink : false,
                is_youtube_link : false,
                youtube_link : '',
                temp_youtube_link : '',
                image_path : '',
                isShowPopupMenu : false,
                menuOptions : {},
                isShowRequest : false,
                isShowRequestComplete : false,
                isRequested : false,
                isHideRequest : true,
            }
        },
        methods : {
            async hideRequest(){
                const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">영상 제작에 대한 흥미가 없으신가요?<br>확인 시 다시는 요청하기가 표시되지 않습니다.</div>`;
                this.$GlobalStore.showConfirm(html, async () => {
                    const parameters = {};
                    const res = await this.$Axios.post('/api/coach/media/request/hide', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.isHideRequest = true;
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '영상 제작에 관심없음', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => {})
            },
            showFiles(){
                this.$refs.image_file.click();
            },
            checkYoutube(){
                if(this.$Util.checkYoutubeLink(this.temp_youtube_link)){
                    this.is_youtube_link = true;
                }
            },
            reset(){
                this.resetImage();
                this.resetYoutube();
            },
            resetImage(){
                this.image_path = '';
            },
            resetYoutube(){
                this.is_youtube_link = false;
                this.temp_youtube_link = '';
                this.youtube_link = '';
            },
            async getMedia(){
                const parameters = {};
                const res = await this.$Axios.get('/api/coach/media', {params : parameters});
                const media = res.data.media;
                if(media){
                    this.isRequested = media.is_requested == '1';
                    this.isHideRequest = media.is_hidden == '1';
                }
                if(media && media.media_path){
                    if(this.$Util.checkYoutubeLink(media.media_path)){
                        this.temp_youtube_link = media.media_path;
                        this.youtube_link = media.media_path;
                        this.is_youtube_link = true;
                        this.resetImage();
                    }else {
                        this.image_path = this.$resourcePath + media.media_path;
                        this.resetYoutube();
                    }
                } else {
                    this.reset();
                }
            },
            async save(is_youtube_save){
                const formData = new FormData();

                if(this.temp_youtube_link !== '' && is_youtube_save){
                    formData.append('youtube_link', this.temp_youtube_link);
                }else if(this.$refs.image_file.value !== '' && !is_youtube_save){
                    formData.append('image_file', this.$refs.image_file.files[0]);
                }

                this.$GlobalStore.showProgress();
                const res = await this.$Axios.post('/api/coach/media/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.$GlobalStore.hideProgress();
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.isShowLink = false;
                    this.getMedia(false);
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            deleteUrl(){
                this.is_youtube_link = false;
                this.temp_youtube_link = '';
            },
            async deleteMedia(){
                const parameters = {};

                this.$GlobalStore.showProgress();
                const res = await this.$Axios.post('/api/coach/media/delete', parameters);
                this.$GlobalStore.hideProgress();
                if(res.data.code === ResponseCode.SUCCESS){
                    this.getMedia();
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            readURL(e) {
                const input = e.currentTarget;

                if (input.files && input.files[0]) {
                    var extension = input.files[0].name.split('.').pop().toLowerCase();

                    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp') {

                        var reader = new FileReader();
                        reader.onload = (e) => {
                            if (input.files[0].size > 1024 * 1024 * 1024) {
                                input.files[0].value = '';
                                this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                                return;
                            }

                            this.image_path = e.target.result;
                            // this.$refs.introduce_image.src =
                            this.youtube_link = '';
                            this.save(false);
                        };
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.');
                    }
                }
            },
            async requestMaking(){
                const parameters = {};
                this.$GlobalStore.showProgress();
                const res = await this.$Axios.post('/api/coach/media/request/making', parameters);
                this.$GlobalStore.hideProgress();
                if(res.data.code === ResponseCode.SUCCESS){
                    this.isShowRequestComplete = true;
                    this.isShowRequest = false;
                    this.isRequested = true;
                    setTimeout(() => {
                        this.isShowRequestComplete = false;
                    }, 2000)
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.save = this.$Once(this.save);
            this.deleteMedia = this.$Once(this.deleteMedia);
            this.requestMaking = this.$Once(this.requestMaking);
            this.hideRequest = this.$Once(this.hideRequest);

            this.menuOptions = {
                labelAndAction: [
                    { label: '삭제', action: () => { this.deleteMedia(); this.isShowPopupMenu = false;} },
                ],
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopupMenu = false;
                }
            }

            this.getMedia();
        }
    }
</script>

<style scoped>
    .title{color:#210F03; font-size:16px; margin-bottom:10px; font-weight:500; }
    .container{background-color:white; border-radius:12px; padding:12px;}
    .container + .container{margin-top:10px;}
    .youtube_link_input{width:100%;outline: none; border:0px;background-color: #f5f5f5; margin-left:10px; color:#210F03;}
    .youtube_link_input::placeholder{color:#BBBBBB}
    .btn{height: 48px; background-color: #F5F5F5; color: #D9D9D9; font-size: 14px; font-weight:500; display:grid; place-items: center;border-radius:12px;}
    .btn.active{color:white; background-color: black;}

    .explanation_front{display:inline-block; width:16px;line-height: 24px;}
    .explanation_back{line-height: 24px; flex:1;}
    .explanation_title{color:#210F03; font-size:14px; font-weight:bold;line-height: 24px;}
    .explanation{color:#210F03; font-size:14px; font-weight:500;display:flex;}

    .fade-enter-active, .fade-leave-active {transition: opacity 0.3s;}
    .fade-enter, .fade-leave-to {opacity: 0;}

</style>